import { Upload } from 'antd';
import styled from 'styled-components';

const { Dragger } = Upload;

export const SUploader = styled(Upload)``;

export const SDragger = styled(Dragger)``;
